import { SET_COMPANIES } from './types';

export function setCompanies(companies) {
	return {
		type: SET_COMPANIES,
		companies
	}
}